import React from "react";
import Slider from "react-slick";

interface CarouselProps {
	slides: React.ReactNode[];
	options?: object;
}

export function Carousel({ slides, options }: CarouselProps) {
	const settings = {
		dots: true,
		infinite: false,
		arrows: false,
		speed: 400,
		slidesToShow: 2,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 576,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
		customPaging: (index: number) => <button>Page {index + 1}</button>,
		...options,
	};
	return <Slider {...settings}>{slides}</Slider>;
}
